import { useCallback, useEffect, useRef } from 'react';

export interface UseDebounceProps {
  debouncedFn: (fn: (...args: any) => any, delay: number) => void;
  cancelDebounce: () => void;
}

export default function useDebounce(): UseDebounceProps {
  const timeoutRef = useRef<any>(null);

  function debouncedFn(fn: (...args: any) => any, delay: number) {
    window.clearTimeout(timeoutRef.current);
    timeoutRef.current = window.setTimeout(() => {
      fn();
    }, delay);
  }

  const cancelDebounce = useCallback(() => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = null;
    }
  }, []);

  useEffect(() => () => cancelDebounce(), [cancelDebounce]);

  return {
    debouncedFn,
    cancelDebounce,
  };
}
